import React from 'react';
import { createRoot } from 'react-dom/client';
//import 'sanitize.css';
import './application.css'; 
import {Provider} from 'react-redux';
import {createStore, compose, applyMiddleware} from 'redux';
import { createHashHistory } from 'history';
import * as Immutable from 'immutable';
import createSagaMiddleware from 'redux-saga';

import {actions, reducerArray} from './Redux/index';
import {combineReducers} from './Utility/HandleActions';
import { LOCAL_STORAGE_KEYS } from './constants';

//import LocationUpdater from './Utility/LocationUpdater';
import IntlProvider from './Utility/ConnectedIntlProvider';

import { unstable_HistoryRouter as HistoryRouter, Route, Routes } from 'react-router-dom';
import Application from './Containers/Application';
import Dashboard from './Containers/Dashboard';
import Settlement from './Containers/Settlement';
import Spot from './Containers/Spot';
import Forward from './Containers/Forward';
import CurrencyPair from './Containers/CurrencyPair';
import rootSaga from './Sagas/index';

import TermsOfUse from './Containers/Pages/TermsOfUse';
import PrivacyStatement from './Containers/Pages/PrivacyStatement';
import API from './Containers/Pages/API';

/**
 * This is the main class which does the bootstrapping of the application.
 */
document.addEventListener('DOMContentLoaded', () => {
    const history = createHashHistory();
    const sagaMiddleware = createSagaMiddleware();

    const initialState = Immutable.fromJS({
        router: { locationBeforeTransitions: history.location }
    });

    const store = createStore(
        combineReducers(reducerArray),
        initialState,
        compose(applyMiddleware(sagaMiddleware)),
    );

    sagaMiddleware.run(rootSaga, { history });

    // It's important to initialize the state before rendering the app
    store.dispatch(actions.System.init());

    const container = document.getElementById('root');
    const root = createRoot(container);

    const getLanguage = () => {
        const fromLocalStorage = window.localStorage.getItem(LOCAL_STORAGE_KEYS.LOCALE);
        if (fromLocalStorage) {
            return fromLocalStorage;
        }
        return navigator.language.split(/[-_]/)[0] || 'en'; // Default to English
    };

    const initialLanguage = getLanguage();
    // Dispatch the initial language to the store so the entire app is in sync
    store.dispatch(actions.UI.Locale.changeLanguage(initialLanguage));

    root.render(
        <Provider store={store}>
            <IntlProvider defaultLocale={initialLanguage}>
                <HistoryRouter history={history} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                    <Routes>
                        <Route path="/" element={<Application />}>
                            <Route index element={<Dashboard />} />
                            <Route path="settlement" element={<Settlement />} />
                            <Route path="spot" element={<Spot />} />
                            <Route path="forward" element={<Forward />} />
                            <Route path="currency-details" element={<CurrencyPair key={window.location.href} />} />
                            <Route path="pages/api" element={<API />} />
                            <Route path="pages/terms-of-use" element={<TermsOfUse />} />
                            <Route path="pages/privacy-statement" element={<PrivacyStatement />} />
                        </Route>
                    </Routes>
                </HistoryRouter>
            </IntlProvider>
        </Provider>
    );
});